module.exports = {
    merchantName: "Wei Dao",
    merchantDomain: "https://weidaocroydonchineserestaurant.co.uk",  // Need correct! project will upload dist to targer domain file in Plesk.
    merchantMenuUrl: "/menu-wei-dao-chinese-restaurant", // target merchant's menu url in alleatapp.com
    // when you building files, fill this info, dont push these to github.
    pleskUsername: 'root',
    pleskPs: '3uyo$9!Ws9',
}
